import React from 'react';
import ReactDOM from 'react-dom';
import {Router} from 'react-router-dom';
import zh from 'antd/es/locale/zh_CN';
import en from 'antd/es/locale/en_US';
import {ConfigProvider} from 'antd';
import history from './libs/history';
import './font/iconfont.css'
import './index.less';
import './i18n';

import App from './App';
import 'moment/locale/zh-cn';
import * as serviceWorker from './serviceWorker';
// import './libs/rem.js';

ReactDOM.render(
  <Router history={history}>
    <ConfigProvider locale={zh}>
      <App/>
    </ConfigProvider>
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
